import BaseRepositoryClass from 'api/utils/BaseRepositoryClass';
import { RepositoryType, } from 'api/utils/RepositoryTypes';
import { CartResponse, } from 'common/types';
import { makeImagesCollectionToDict, } from 'common/functions';

const transformCollectionImagesToObjectNotation = (data: CartResponse) => ({
    ...data,
    items: data.items.map(item => ({
        ...item,
        product: {
            ...item.product,
            // @ts-ignore
            images: item.product.images.reduce(makeImagesCollectionToDict, {})
        },
    })),
});

class CartRepository extends BaseRepositoryClass implements RepositoryType {
    get(token: string) {
        const transformers = {
            response: [
                JSON.parse,
                transformCollectionImagesToObjectNotation,
            ],
        };

        return this
            .requester
            .setTransformers(transformers)
            .get<CartResponse>(`grant/cart/${token}`);
    }

    put(token: string, id: number, quantity: number) {
        return this
            .requester
            .put<CartResponse>(`${this.apiVersion}/grant/cart/${token}/item/${id}`, { quantity });
    }

    post(token: string, data: any) {
        return this
            .requester
            .post<any>(
                `grant/cart/${token}/promotional-set`,
                 JSON.stringify(data), 
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
    }
}

export default CartRepository;
